export const sanitizeConsentTexts = (consentTextsArray) => {
  return consentTextsArray.map((singleConsentText) => {
    delete singleConsentText['@id'];
    delete singleConsentText['website'];
    delete singleConsentText['@type'];
    delete singleConsentText['id'];
    delete singleConsentText['date'];
    delete singleConsentText['originId'];
    return singleConsentText;
  });
};
